function p(f, n) {
  return process.env.NODE_ENV === "production" ? () => null : (r, e, o, t, u) => {
    const a = o || "<<anonymous>>", d = u || e;
    return typeof r[e] < "u" ? new Error(`The ${t} \`${d}\` of \`${a}\` is deprecated. ${n}`) : null;
  };
}
export {
  p as default
};
//# sourceMappingURL=deprecatedPropType.mjs.map
